import { useActiveOrg } from '../active-org.ts';
import { useAuth } from '../api.ts';

import { Select } from './Select.tsx';

/**
 * Inline org picker — a labelled dropdown that sits at the top of an
 * org-scoped settings page (Platform Map, Engineers, Integrations) in
 * place of a static heading. Picking an org re-scopes the page in place
 * by writing the shared active-org seam (`active-org.ts`); the enclosing
 * {@link SettingsLayout} re-resolves `{ orgSlug, role }` and hands it back
 * down through the router Outlet context.
 *
 * Uses the shared {@link Select} (page-level `md` size) so it matches every
 * other dropdown in the app.
 */
export function OrgPicker() {
  const auth = useAuth();
  const orgs = auth.status === 'signed-in' ? auth.me.orgs : [];
  const { active, switchActive } = useActiveOrg(orgs);

  if (orgs.length === 0 || !active) return null;

  return (
    <Select
      label="Active organization"
      size="md"
      style={{ minWidth: 180 }}
      value={active.slug}
      onChange={(e) => switchActive(e.target.value)}
    >
      {orgs.map((o) => (
        <option key={o.slug} value={o.slug}>
          {o.name}
        </option>
      ))}
    </Select>
  );
}
